import { getIntersectionObserverConstructor } from "../../../components";
import React from "react";
const defaultsOptions = {
    rootMargin: "0px",
    threshold: .01
};
export function useIntersectionObserver(props) {
    const idleCallbackID = React.useRef(0);
    const observer = React.useRef({});
    const [isVisible, setIsVisible] = React.useState(false);
    const unRegisterDom = (element) => {
        if (element) {
            observer.current.unobserve(element);
        }
    };
    const domRegister = (element) => {
        if (element) {
            observer.current.observe(element);
        }
    };
    const updateOnIdle = (entries) => {
        window.cancelAnimationFrame(idleCallbackID.current);
        idleCallbackID.current = window.requestAnimationFrame(setIsVisible.bind(useIntersectionObserver, entries[0].isIntersecting));
    };
    React.useEffect(() => {
        const _OBS = getIntersectionObserverConstructor();
        observer.current = new _OBS(updateOnIdle, Object.assign(Object.assign({}, defaultsOptions), props));
        setIsVisible(observer.current["faked"] || false);
    }, []);
    return {
        isVisible,
        domRegister,
        unRegisterDom
    };
}
//# sourceMappingURL=useIntersectionObserver.js.map